import { lazyIsSearchBoxEmpty } from 'owa-search';
import { startSearch } from 'owa-search-actions';
import { SearchScenarioId } from 'owa-search-store';

/**
 * Common piece of code that checks if search box isn't empty and kicks a search with applied refiners
 */
export default async function startSearchWithRefiners() {
    // If search box isn't empty, kick off a search.
    const isSearchBoxEmpty = await lazyIsSearchBoxEmpty.import();
    if (!isSearchBoxEmpty(SearchScenarioId.Calendar)) {
        startSearch('SearchScopeRefiner', SearchScenarioId.Calendar, false /* explicitSearch */);
    }
}
